export default __webpack_public_path__ + "static/media/butter1.785d2a5a.jpg";